export var RepeatAlarm;
(function (RepeatAlarm) {
    RepeatAlarm[RepeatAlarm["AlarmRepeatUntilResolved"] = 1] = "AlarmRepeatUntilResolved";
    RepeatAlarm[RepeatAlarm["AlaramRepeats3Times"] = 2] = "AlaramRepeats3Times";
    RepeatAlarm[RepeatAlarm["NoRepeat"] = 3] = "NoRepeat";
})(RepeatAlarm || (RepeatAlarm = {}));
export var AlertType;
(function (AlertType) {
    AlertType[AlertType["EmailAndSMS"] = 1] = "EmailAndSMS";
    AlertType[AlertType["EmailOnly"] = 2] = "EmailOnly";
    AlertType[AlertType["SMSOnly"] = 3] = "SMSOnly";
    AlertType[AlertType["WhatsAppOnly"] = 4] = "WhatsAppOnly";
    AlertType[AlertType["EmailAndWhatsApp"] = 5] = "EmailAndWhatsApp";
    AlertType[AlertType["SmsAndWhatsApp"] = 6] = "SmsAndWhatsApp";
    AlertType[AlertType["EmailSmsAndWhatsApp"] = 7] = "EmailSmsAndWhatsApp";
})(AlertType || (AlertType = {}));
export var NodeBehaviour;
(function (NodeBehaviour) {
    NodeBehaviour[NodeBehaviour["Normal"] = 0] = "Normal";
    NodeBehaviour[NodeBehaviour["NoNodeCommunication"] = 1] = "NoNodeCommunication";
})(NodeBehaviour || (NodeBehaviour = {}));
/** Where a reading stands against the limits of its sensor (API `SensorLimitStatus`). */
export var SensorLimitStatus;
(function (SensorLimitStatus) {
    SensorLimitStatus[SensorLimitStatus["Normal"] = 0] = "Normal";
    SensorLimitStatus[SensorLimitStatus["High"] = 1] = "High";
    SensorLimitStatus[SensorLimitStatus["Low"] = 2] = "Low";
})(SensorLimitStatus || (SensorLimitStatus = {}));
